import React, { memo } from 'react';
import PropTypes from 'prop-types';
var Anchor = function Anchor(_ref) {
  var url = _ref.url,
    label = _ref.label,
    classes = _ref.classes,
    target = _ref.target;
  var props = {
    href: url
  };
  if (classes.length > 0) {
    props.className = classes.join(' ');
  }
  if (target !== null) {
    props.target = target;
    if (props.target === '_blank') {
      props.rel = 'noopener noreferrer';
    }
  }
  return /*#__PURE__*/React.createElement("a", props, label);
};
Anchor.defaultProps = {
  classes: [],
  target: null
};
Anchor.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string),
  target: PropTypes.string
};
export default /*#__PURE__*/memo(Anchor);